import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course02 from "../../../course/course-02/course";
import lesson0204 from "../../../lesson/course-02/lesson-04/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "dce05c3b-4447-477b-b922-2cd70137b203",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0204),
    lesson: lesson0204,
  },
];

export default lessonLinks;
